<template lang="pug">
div(class="quill-editor")
  slot(name="toolbar")
  div(ref="editor")
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import Quill from 'quill';
// import { ImageDrop } from 'quill-image-drop-module';
// import ImageResize from 'quill-image-resize-module';

// Quill.register('modules/imageDrop', ImageDrop);
// Quill.register('modules/imageResize', ImageResize);

export default {
    name: 'CEContentEditorQuill',

    props: {
        content: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        options: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    data() {
        return {
            editor: null
        };
    },

    mounted() {
        this.init();
    },

    beforeDestroy() {
        this.editor = null;
    },

    watch: {
        content(newVal, oldVal) {
            if (!this.editor) return;
            if (newVal) {
                this.editor.pasteHTML(newVal);
                // Move caret to the end of the text
                this.editor.setSelection(newVal.length - 1, newVal.length - 1);
            } else if (!newVal) {
                this.editor.setText('');
            }
        }
    },

    methods: {
        init() {
            const defaultOptions = {
                modules: {
                    toolbar: [
                        [{ header: [1, 2, 3, false] }],
                        ['bold', 'italic', 'underline', 'strike'],
                        // [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['clean'],
                        ['link'] // , 'image', 'video']
                    ]
                },
                theme: 'snow',
                bounds: '.quill-editor',
                // imageDrop: true,
                // imageResize: {
                //     displayStyles: {
                //         backgroundColor: 'black',
                //         border: 'none',
                //         color: 'white'
                //     },
                //     modules: ['Resize', 'DisplaySize', 'Toolbar']
                // }
            };

            const options = Object.assign({}, defaultOptions, this.options);

            this.editor = new Quill(this.$refs.editor, options);

            this.editor.root.innerHTML = this.content;

            this.editor.on('text-change', () => this.update());
        },

        update() {
            this.$emit(
                'onUpdate',
                this.editor.getText()
                    ? this.editor.root.innerHTML
                    : ''
            );
        }
    }
};
</script>

<style scoped>
.quill-editor {
  height: 20rem;
  border-bottom: none;
  z-index:1000000;
}
</style>



// WEBPACK FOOTER //
// src/components/content/CEContentEditorQuill.vue